<template>
  <PageLayout
    :page-title="pageTitle"
    :show-breadcrumbs="false"
    :show-page-header="false"
    :breadcrumb-items="breadcrumbItems"
    :locale="locale"
  >
    <div v-if="isLoading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-else class="col-xl-8 offset-xl-2">
      <ContactDetailsForm
        v-if="contact && contact.id"
        :customer="contact"
        :show-personal-details-header="true"
        :show-id-number="showIdNumber"
        :show-gender="showGender"
        :show-date-of-birth="showBirthDate"
        :show-relationship-type="true"
        :basic-details-card-title="`Edit ` + this.$t('sidebar.owner')"
        @customer-updated="handleContactUpdated"
      />
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from "../layouts/PageLayout.vue";
import ContactDetailsForm from "../ContactDetails/ContactDetailsForm.vue";
import {handleError, showWarning} from "../../utils/notification.utils";
import permissionService from "../../service/permission.service";
import contactService from "../../service/contact.service";

export default {
  name: "UpdateContactPage",
  components: {
    PageLayout,
    ContactDetailsForm
  },
  data() {
    return {
      pageTitle: `Edit ` + this.$t('sidebar.owner'),
      locale: this.$i18n.locale,
      isLoading: true,
      contact: {},
      contactId: null,
      contextId: null,
      breadcrumbItems: [
        {label: 'Home', to: '/dashboard'},
        {label: this.$t('sidebar.owners'), to: '/contacts'},
        {label: 'Edit', to: '#'}
      ],
      showIdNumber: false,
      showGender: false,
      showBirthDate: false,
      pagePermissions: ["CUSTOMER_UPDATE"]
    };
  },
  methods: {
    retrieveContact() {
      this.isLoading = true;
      contactService.findById(this.contextId, this.contactId)
        .then(response => {
          if (response.data.code === 'SUCCESS') {
            this.contact = response.data.data;
          } else {
            showWarning(response.data.narrative || "Failed to load contact");
            this.$router.push('/contacts');
          }
        })
        .catch(e => {
          handleError(e);
          this.$router.push('/contacts');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleContactUpdated(contact) {
      // Navigate to the contacts list page
      this.$router.push('/contacts');
    }
  },
  async mounted() {
    if (!this.$store.state.auth.user) {
      await this.$router.push("/login");
      return;
    }

    // Get contact ID from route params
    this.contactId = this.$route.params.id;
    if (!this.contactId) {
      await showWarning('Invalid contact ID');
      await this.$router.push('/contacts');
      return;
    }

    // Get context ID
    this.contextId = localStorage.getItem('contextId') || localStorage.getItem('selectedContextId');
    if (!this.contextId) {
      await showWarning('Missing context ID');
      await this.$router.push('/contacts');
      return;
    }

    // Check permissions
    const result = await permissionService.checkPermissions(this.pagePermissions);
    if (!result.success) {
      await showWarning('Error: You do not have permission to update contacts');
      await this.$router.push('/contacts');
      return;
    }

    // Show additional fields for specific locales
    if (['levies', 'school', 'medical'].includes(this.locale)) {
      this.showIdNumber = true;
      this.showGender = true;
      this.showBirthDate = true;
    }

    // Retrieve the contact data
    this.retrieveContact();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/contacts/UpdateContactPage.vue